/**
 * 上门门店省市区：级联选择 → 回填 province/city/district 名称（与 o2o_store 字段对齐）
 * 后端仍存名称字符串，不存 areaId。
 */

export type StoreAreaNames = {
  province: string
  city: string
  district: string
}

/** checkStrictly：允许只选到市（区选填，对齐库表 district 可空） */
export const storeAreaCascaderProps = {
  label: 'name',
  value: 'id',
  children: 'children',
  emitPath: true,
  checkStrictly: true
}

/** 按级联 path 解析省/市/区名称 */
export function resolveStoreAreaByPath(tree: any[], path?: number[]): StoreAreaNames {
  if (!path?.length) {
    return { province: '', city: '', district: '' }
  }
  let nodes = tree
  const names: string[] = []
  for (const id of path) {
    const node = nodes.find((n: any) => n.id === id)
    if (!node) break
    names.push(String(node.name || ''))
    nodes = node.children || []
  }
  return {
    province: names[0] || '',
    city: names[1] || names[0] || '',
    district: names[2] || ''
  }
}

function nameLooseMatch(a?: string, b?: string): boolean {
  if (!a || !b) return false
  if (a === b) return true
  const strip = (s: string) => s.replace(/[省市州区县]/g, '')
  const sa = strip(a)
  const sb = strip(b)
  return !!sa && !!sb && (sa === sb || a.includes(sb) || b.includes(sa))
}

/**
 * 编辑回填：用已存名称反查级联 path。
 * 优先完整「省→市→区」，其次「省→市」。
 */
export function findStoreAreaPathByNames(
  tree: any[],
  province?: string,
  city?: string,
  district?: string
): number[] | undefined {
  if (!tree?.length) return undefined

  for (const p of tree) {
    if (province && !nameLooseMatch(String(p.name), province)) continue

    for (const c of p.children || []) {
      if (district) {
        const d = (c.children || []).find((x: any) => nameLooseMatch(String(x.name), district))
        if (d && (!city || nameLooseMatch(String(c.name), city))) {
          return [p.id, c.id, d.id]
        }
        if (nameLooseMatch(String(c.name), district)) {
          return [p.id, c.id]
        }
      }
      if (city && nameLooseMatch(String(c.name), city)) {
        if (district) {
          const d = (c.children || []).find((x: any) => nameLooseMatch(String(x.name), district))
          if (d) return [p.id, c.id, d.id]
        }
        return [p.id, c.id]
      }
    }
  }

  return undefined
}
